import { useCallback } from 'react';

import { useErrorMessage } from '@nucleus-commerce/admin-kit/errors';

import { scheduleErrorCopy, type ScheduleAction } from '../api/schedule-errors';

import { useScheduleCopy } from './use-schedule-copy';

/**
 * The message for a failed schedule call: the schedule copy when the code is one of ours (store
 * names looked up from the session), else the app's generic message for the code.
 */
export function useScheduleErrorMessage() {
  const generic = useErrorMessage();
  const text = useScheduleCopy();

  return useCallback(
    (error: unknown, action: ScheduleAction): string => {
      const copy = scheduleErrorCopy(error, action);
      return copy ? text(copy) : generic(error);
    },
    [generic, text],
  );
}
